export default __webpack_public_path__ + "static/media/user-icon-border-bottom-round.2ba8d00f.svg";